import { digObject } from '@domain-group/javascript-utils'

import { PublicationBookingModel, PublicationBookingItemModel } from '@models/types'
import { EntitiesState } from '@redux/entities'

export type PreflightStatusFilter = 'all' | 'approved' | 'rejected' | 'required'

/* eslint-disable import/prefer-default-export */
export const matchBookingPreflightStatus = (
  publicationBooking: PublicationBookingModel,
  statuses: EntitiesState['statuses'],
  filterPreflightStatus?: PreflightStatusFilter,
) => {
  if (!filterPreflightStatus) return true

  const { preflight_status_id, status_id } = publicationBooking
  // @ts-expect-error TS2538
  const publicationBookingStatus = statuses[status_id]
  // @ts-expect-error TS2538
  const preflightStatus = statuses[preflight_status_id]

  // Preflightable bookings must be approved
  if (publicationBookingStatus?.key !== 'approved') return false

  if (filterPreflightStatus === 'all') return true
  if (filterPreflightStatus === 'approved') return preflightStatus?.key === filterPreflightStatus
  if (filterPreflightStatus === 'rejected') return preflightStatus?.key === filterPreflightStatus
  if (filterPreflightStatus === 'required') return !preflight_status_id || preflightStatus?.key === 'rejected'

  return false
}

export type BookingStatusFilter = 'all' | 'approved' | 'booked' | 'current' | 'ftp_transfer_successful' | 'pending'

export const matchPublicationBookingStatus = (
  publicationBooking: PublicationBookingModel,
  statuses: EntitiesState['statuses'],
  filterStatus?: BookingStatusFilter,
) => {
  if (!filterStatus) return true

  const { ftp_transfer_successful, status_id } = publicationBooking
  // @ts-expect-error TS2538
  const publicationBookingStatus = statuses[status_id]

  if (filterStatus === 'approved') return publicationBookingStatus?.key === filterStatus
  if (filterStatus === 'booked') return publicationBookingStatus?.key === filterStatus
  if (filterStatus === 'current') return publicationBookingStatus?.key !== 'pending'
  if (filterStatus === 'ftp_transfer_successful') return ftp_transfer_successful === false
  if (filterStatus === 'pending') return publicationBookingStatus?.key === filterStatus

  return false
}

type GetBookingConfirmationIdProps = {
  publicationBooking: PublicationBookingModel,
  publicationBookingItems: PublicationBookingItemModel[],
}

export const getBookingConfirmationId = (props: GetBookingConfirmationIdProps) => {
  const { publicationBooking, publicationBookingItems } = props
  const { booking_confirmation_id } = publicationBooking

  if (booking_confirmation_id) return booking_confirmation_id

  if (publicationBookingItems?.length > 1) return ''

  const publicationBookingItem = publicationBookingItems[0]

  return digObject(publicationBookingItem, 'booking_confirmation_id', '')
}
